module.exports = __webpack_public_path__ + "img/module-thumb.94376606.jpg";